import React from 'react';
import { Helmet } from 'react-helmet';

export const PageTitle = (props: { title?: string }) => {
  const pageTitle = props.title
    || 'Likvidera aktiebolag - Lagerbolag - Citadellet Bolagsservice AB';
  return (
    <Helmet>
      <title>{pageTitle}</title>
    </Helmet>
  );
};
